import { Link } from '@remix-run/react'

import { IconMail, IconPhone } from '~/components'
import { CONTACT_INFO } from '~/features/common/contact-methods'

const officeMapInfoLinks = [
  { href: '/faq', text: 'よくある質問' },
  {
    href: 'https://media.officemap.jp/request/',
    text: 'オフィス掲載に関して',
    target: '_blank',
    rel: 'noreferrer',
  },
  { href: '/contact', text: 'お問い合わせ' },
  {
    href: 'https://www.soho-tokyo.com/',
    text: 'SOHO東京',
    target: '_blank',
    rel: 'noreferrer',
  },
  {
    href: 'https://prop-form.com/',
    text: 'プロップフォーム',
    target: '_blank',
    rel: 'noreferrer',
  },
  { href: 'https://media.officemap.jp/', text: 'オフィスマップメディア' },
  { href: '/privacy-policy', text: 'プライバシーポリシー' },
  { href: '/terms', text: '利用規約' },
  {
    href: 'https://trancereal.co.jp',
    rel: 'noreferrer',
    target: '_blank',
    text: '運営会社',
  },
]

const FooterContact = () => {
  return (
    <div className="flex w-[290px] shrink-0 flex-col items-start pt-8 lg:pt-0">
      <h3 className="mb-2 text-[14px] font-semibold text-gray-700">
        お問い合わせ
      </h3>
      <div className="flex flex-col gap-y-3">
        <a
          className="flex flex-col gap-y-0.5 hover:underline focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2"
          href={CONTACT_INFO.phoneHref}
        >
          <span className="flex items-center gap-x-1.5 text-base font-bold text-textPrimary">
            <IconPhone className="h-4 w-4 text-brand" />
            {CONTACT_INFO.phone}
          </span>
          <span className="pl-[22px] text-xs text-grayText">
            {CONTACT_INFO.hours}
          </span>
        </a>
        <a
          className="flex items-center gap-x-1.5 text-sm font-medium text-textPrimary hover:underline focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2"
          href={CONTACT_INFO.emailHref}
        >
          <IconMail className="h-4 w-4 text-brand" />
          {CONTACT_INFO.email}
        </a>
      </div>
    </div>
  )
}

const BottomNavigation = () => {
  return (
    <nav className="flex w-full flex-col items-center bg-[#EAF7F8] px-8 py-12">
      <div className="flex w-full max-w-[1280px] flex-col items-center lg:flex-row lg:items-start lg:justify-center lg:gap-x-16 xl:gap-x-24">
        <div className="flex w-[290px] shrink-0 flex-col items-start lg:-mt-4">
          <div className="flex items-center gap-x-3">
            <img
              alt="footer-logo"
              aria-label="footer-logo"
              className="h-[130px] w-[130px]"
              src="/logo.svg"
            />
            <h2
              aria-label="footer-logo-title"
              className="min-w-[143px] text-[11px] font-bold leading-tight text-brand"
            >
              シェアオフィス
              <br />
              レンタルオフィス検索サイト
            </h2>
          </div>
          <span className="-mt-8 text-xs text-brand">
            Copyright © officeMAP. All Rights Reserved.
          </span>
        </div>

        <FooterContact />

        <div className="flex flex-col justify-center px-2 pt-8 lg:pt-0">
          <h3 className="mb-2 text-[14px] font-semibold text-gray-700">
            オフィスマップに関する情報
          </h3>
          <div className="flex flex-col gap-y-4">
            <div className="flex flex-wrap items-center">
              {officeMapInfoLinks.map((link, index) => (
                <div className="flex items-center py-2" key={link.href}>
                  {link.target ? (
                    <a
                      className="text-sm text-[#3672CD] hover:underline"
                      href={link.href}
                      rel={link.rel}
                      target={link.target}
                    >
                      {link.text}
                    </a>
                  ) : (
                    <Link
                      className="text-sm text-[#3672CD] hover:underline"
                      to={link.href}
                    >
                      {link.text}
                    </Link>
                  )}
                  {index < 8 && (
                    <div className="mx-4 h-4 border-r border-gray-300" />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export const TopFooter = () => {
  return (
    <footer
      aria-label="footer"
      className="flex w-full flex-col justify-between gap-y-4 border-t border-grayBorder bg-white text-sm"
    >
      <BottomNavigation />
    </footer>
  )
}
